import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Card, CardMedia, CardContent } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import ToggleButton from '../../component/ToggleButton/index.jsx';
import Otp_Verification from "../otp_verification/Otp_Verification";
import firebase from "../../config/firebase/index";
import OtpInput from "react-otp-input";
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReactGA from 'react-ga';
import CheckBox from '../../component/CheckboxAtom/index.jsx';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import encSecret from '../../config/encryption/index.js';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Suggest_Bid from '../Suggest_Bid/Suggest_Bid.js';
var CryptoJS = require("crypto-js");



const Mobile_Browser_Market1 = (props) => {
    const classes = useStyles();
    const [isToggled, setIsToggled] = useState(false);
    const [final, setfinal] = useState("");
    const [mynumber, setnumber] = useState("");
    const [showOtp, setShowOtp] = useState(false);
    const PhoneNo = props.PhoneNo;
    const [Otp, setOtp] = useState("");
    const [LoggedIn, setLoggedIn] = useState(false);
    const [mobileField, setMobileField] = useState(false);
    const closePopUp = props.closePopUp;
    const [show, setShow] = useState(false);
    const [link, setLink] = useState("");
    const [flag, setFlag] = useState(props.methodFlag);
    const dealId = props.dealId;
    const [call, setCall] = useState(0);
    const [text, setText] = useState(0);
    const [verify, setVerify] = useState(false);
    const [showSuggestion, setShowSuggestion] = useState(false);
    const loggedIn = props.loggedIn;

    const checkedTnC = (val) => {
        console.log("Selected Val :: ", val);
        setVerify(val);
    }

    const Product = async () => {
        if (dealId) {
            firebase.database().ref(`Product/${dealId}`).on('value', deal => {
                const oldDeal = deal.val()
                setCall(parseInt(oldDeal.analytics.phone))
                setText(parseInt(oldDeal.analytics.whatsapp))
            })
        }
    }


    const numberValidation = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }


    const OtpValidation = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const whatsappOptIn = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    useEffect(() => {
        setLink(props.link);
        setFlag(props.methodFlag);
        console.log(props.methodFlag);
        Product();
        if (loggedIn && flag == "suggest")
            setShowSuggestion(true);

        console.log("Type ::: ", props.type);
    }, [])

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const createdAt = () => {
        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }


    const createCustomer = async () => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: "Unknown",
            PhoneNo: mynumber,
            img: "",
            method: "call",
            time: createdAt()
        };

        customerRef.push(customer);
    };

    const createCustomer1 = async () => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: "Unknown",
            PhoneNo: mynumber,
            img: "",
            method: "whatsapp",
            time: createdAt()
        };

        customerRef.push(customer);
    };

    const createUser = async () => {
        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(mynumber).once("value", snapshot => {
                const userData = snapshot.val();
                console.log("NewUser ::: ", userData);
                if (!userData) {
                    const UserRef = firebase.database().ref("Users");
                    const user = {
                        City: "",
                        Name: CryptoJS.AES.encrypt("New User", encSecret.key).toString(),
                        PhoneNo: mynumber,
                        dealerFlag: false,
                        img: "",
                        createAt: new Date().toISOString(),
                        updatedAt: new Date().toISOString(),
                        // whatsappOptIn: isToggled ? true : false,
                        // whatsappOpInText: whatsappOpInText
                    };
                    UserRef.push(user);
                    setLocalUser(mynumber);
                    // localStorage.setItem("isLoggedIn", true);
                    // localStorage.setItem("user", JSON.stringify([user]));
                }
                else {
                    setUser(userData);
                }

            });
    }

    const setUser = (userData) => {
        let user;
        for (let key in userData) {
            user = {
                id: key,
                ...userData[key]
            }
        }
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("Phone Number", mynumber);
        localStorage.setItem("user", JSON.stringify([user]));
        if (flag != "suggest")
            closePopUpHandler();
        if (props.methodFlag == "suggest")
            props.hide(props.type);
        // window.location.reload();
    }

    const setLocalUser = (mynumber) => {
        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(mynumber).once("value", snapshot => {
                const userData = snapshot.val();
                console.log("NewUser ::: ", userData);
                setUser(userData);
            })
    }

    const reEnterDetails = () => {
        props.reEnter();
    }

    const openSuggestBox = () => {
        createUser();
        // setShowSuggestion(true);
    }

    const NoOfCalls = () => {
        firebase.database().ref(`Product/${dealId}/analytics/phone`).set(call + 1);
        createCustomer();
        createUser();
    }

    const NoOfWhatsapp = async () => {
        firebase.database().ref(`Product/${dealId}/analytics/whatsapp`).set(text + 1)
        createCustomer1();
        createUser();
    }


    const closePopUpHandler = () => {
        closePopUp(false)
    };

    const signin = () => {

        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            "recaptcha-container",
            {
                size: "invisible",
            }
        );
        const appVerifier = window.recaptchaVerifier;
        firebase
            .auth()
            .signInWithPhoneNumber("+91" + mynumber, appVerifier)
            .then((confirmationResult) => {
                setfinal(confirmationResult);
                setShowOtp(true)

            })
            .catch((error) => {
                console.log("error", error);

            });
    };

    const resendOtp = () => {
        const appVerifier = window.recaptchaVerifier;
        firebase
            .auth()
            .signInWithPhoneNumber("+91" + mynumber, appVerifier)
            .then((confirmationResult) => {
                setfinal(confirmationResult);
                setShow(false);

            })
            .catch((error) => {
                console.log("error", error);

            });
    }


    const handlePhoneEdit = (event) => {
        const phoneNo = event.target.value
        if (phoneNo.length == 10) {
            setnumber(phoneNo)
            numberValidation("Sign Up", "Value Inserted", "Phone number filled - bottom sheet");
        }
    }

    const otpHandleChange = (otp) => {
        setOtp(otp);
        if (otp.length == 6) {
            ValidateOtp(otp);
        }


    };

    const optIn = (val) => {
        if (val)
            whatsappOptIn("SignUp", "Validation", "Whatsapp opt-in - bottom sheet");
    }

    const ValidateOtp = (Otp) => {
        if (Otp === null || final === null) return;
        final
            .confirm(Otp)
            .then((result) => {
                setLoggedIn(true);
                setShow(false);
                OtpValidation("Sign Up", "Value Inserted", "OTP entered correctly - bottom sheet");

            })
            .catch((err) => {
                setShow(true);
                OtpValidation("Sign Up", "Validation", "OTP entered incorrectly - bottom sheet");

            });
    };

    return (
        <Grid p={2} >
            {/* {!showSuggestion ?
                <> */}
            <NoFollowMeta />
            <Box mt={1} ml={2} mr={2}>
                <CloseIcon style={{ float: "right", fill: "black", position: "absolute", right: "2px", top: "-1px", background: "lightgrey", fontSize: "26px", borderRadius: "50%", padding: "5px" }} onClick={closePopUpHandler} />

                {props.methodFlag == "suggest" ? <ArrowBackOutlinedIcon onClick={reEnterDetails} /> : <></>}
                <Typography variant="h6" className={classes.textAbove} style={{ fontWeight: 600 }} >{flag == 'suggest' ? "बोली" : "कॉल  करने"} के लिए अपना नंबर दर्ज़ करे</Typography>
            </Box>
            <Box mt={2} ml={2} mr={2}>
                <Typography variant="body">अपना व्हाट्सप्प नंबर दर्ज़ करे</Typography>
            </Box>
            <Box className={classes.headerBrowser2}>
                <WhatsAppIcon className={classes.headerBrowser3} style={{ color: flag == 'whatsapp' ? 'green' : '#53252f' }} />
                <TextfieldAtom placeholder=""
                    type="number"
                    disabled={mobileField}
                    inputMode="numeric"
                    onChange={handlePhoneEdit}
                    startIcon={<EditIcon />} />
                {/* <Typography variant="body1" style={{ fontWeight: 'bold' }} onClick={signin}>otp भेजे</Typography> */}
            </Box>

            {showOtp ?
                (<div style={{ marginTop: 20 }}>
                    <Typography variant="h7" style={{ fontWeight: 'bold', margin: 20 }}>ओटीपी भरें</Typography>
                    <Box className={classes.otpCenter}>
                        <OtpInput
                            numInputs={6}
                            className={classes.otp}
                            value={Otp}
                            onChange={otpHandleChange}
                            autocomplete="one-time-code"
                            isInputNum={true}
                            type="text"
                            inputMode="numeric"
                            pattern="[+-]?\d+(?:[.,]\d+)?"
                        />


                        <Typography onClick={resendOtp} style={{ fontSize: '16px', fontWeight: 700, textDecoration: "underline", textAlign: 'center', margin: 20, color: flag == 'whatsapp' ? 'green' : '#53252f' }}>पुनः भेजे</Typography>
                    </Box>
                    {show ?
                        <Typography variant="h7" style={{ fontWeight: 'bold', margin: "0 20px" }}>कृपया मान्य ओटीपी दर्ज करें</Typography> :
                        <Typography></Typography>
                    }
                    <Box mt={2} ml={2} mr={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <ToggleButton rounded={true} isToggled={isToggled} onToggle={(val) => { setIsToggled(val); optIn(val); }} />
                        <Typography variant="h7" className={classes.textMiddleSet}>अपने व्हाट्सप्प पर इस और इसी तरह के सौदों पर अपडेट प्राप्त करे</Typography>
                    </Box>
                    <Box mt={2} ml={4} mr={3} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CheckBox checkedTnC={checkedTnC}
                            label={
                                <div>
                                    <span>By using the platform the user agrees to the  </span>
                                    <a href={'/t&c'}>terms and conditions</a>
                                    <span> and </span>
                                    <a href={'/privacy-policy'}>privacy policy</a>
                                    <span> and  of the company.</span>
                                </div>
                            }
                        />
                    </Box>
                    <Box className={classes.contetnArrange}>
                        {LoggedIn ?
                            <> {flag != 'whatsapp' ?
                                <Box mr={1} fullwidth>
                                    {flag == "suggest" ?
                                        <ButtonAtom
                                            startIcon={<CallIcon />}
                                            name="बोली लगाएं"
                                            cclass={verify ? "btnWithRedStatic" : "disabledBtnColor"}
                                            onClick={verify ? openSuggestBox : ''}
                                        />
                                        :
                                        <a href={link} style={{ textDecoration: 'none' }}>
                                            <ButtonAtom
                                                startIcon={<CallIcon />}
                                                name="कॉल करे "
                                                cclass={verify ? "btnWithRedStatic" : "disabledBtnColor"}
                                                onClick={verify ? NoOfCalls : ''}
                                            /></a>
                                    }
                                </Box> :
                                <Box ml={1} fullwidth>
                                    <a href={link} style={{ textDecoration: 'none' }}>
                                        <ButtonAtom
                                            startIcon={<WhatsAppIcon />}
                                            name="व्हाट्सप्प करे"
                                            cclass={verify ? "whatsUpBtn" : "disabledBtnColor"}
                                            onClick={verify ? NoOfWhatsapp : ''}
                                        /></a>
                                </Box>}
                            </> :
                            <>
                                {flag != 'whatsapp' ?
                                    <Box mr={1} fullwidth>
                                        <ButtonAtom
                                            startIcon={<CallIcon />}
                                            name={flag == "suggest" ? "बोली लगाएं" : "कॉल करे "}
                                        />
                                    </Box> :
                                    <Box ml={1} fullwidth>
                                        <ButtonAtom
                                            startIcon={<WhatsAppIcon />}
                                            name="व्हाट्सप्प करे"
                                            cclass="whatsUpBtn"
                                        />
                                    </Box>}
                            </>


                        }
                    </Box>
                </div>)
                :
                (<Box mr={2} mt={3} ml={2} mb={3} fullwidth>
                    <ButtonAtom onClick={signin} cclass={flag != 'whatsapp' ? "btnWithRedStatic" : "whatsUpBtn"}
                        name="आगे बढ़ने के लिए ओटीपी भेजें"
                    />
                </Box>)
            }

            {/* <Box>
                
                
                
                
               
            </Box>
             */}
            <div id="recaptcha-container"></div>
            {/* </> :
                <div>
                    <Suggest_Bid PhoneNo={PhoneNo} closePopUp={props.closePopUp} link={link} quantityUnit={props.quantityUnit} methodFlag={flag} dealId={dealId} />
                </div>
            } */}

        </Grid >

    )
};

const useStyles = makeStyles(() => ({
    textAbove: {
        marginTop: '20px',
    },
    otpCenter: {
        display: 'flex',
        justifyContent: 'center',
    },
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(180deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        marginTop: '25px',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '22px auto',
        marginTop: '-45px',
        height: '435px',
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'

    },
    textMiddleSet: {
        marginLeft: '18px',
    },
    punnCenter: {
        marginLeft: '20px',
        marginTop: '25px',
    },
    otpBoxUi: {
        justifyContent: 'center',
        margin: '30px 0',
        background: '#fff',
        color: 'black',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',

    },
    otpBoxUi1: {

        justifyContent: 'space-between',
    },
    otp: {
        size: 16,
        margin: 'auto 5px',
        '& input': {
            width: '36px !important',
            minHeight: 50,
            border: '0 !important',
            background: 'rgba(83, 37, 47, 0.05)',
            borderRadius: 4,
            color: '#000',
            boxSizing: 'border-box',
            marginBottom: 10,
        }
    },
    topIconImage: {
        marginTop: 'auto 5px',
        position: 'absolute !important',
        left: '90%',
        bottom: '90%',
        transform: 'translate(-50%, -50%)',
        fill: 'white',
        cursor: 'pointer',
    }

}));


export default Mobile_Browser_Market1;
